import React, { Component } from "react";
import {FormBlocks} from '../FormBlocks';
import {formFieldsAttributes} from '../../../FormBuilderFunctions/FieldProps';
import { withRouter } from 'react-router';
import SingleUserModal from './SingleUserModal';
import Autocomplete from "../../../../AutoComplete";
import http from '../../../../../services/http';
import Wrp from '../../../../../hoc/Wrp/Wrp';
import ReactTags from '../../../../ReactTags';
import {getUserInfo} from '../../../../../Utils/UserFunctions';
import MultiUserModel from "./MultiUserModel";


const KeyCodes = {
  comma: 188,
  enter: 13,
};
let delimiters = [KeyCodes.comma, KeyCodes.enter];

class UserField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lookupIcon:'fas fa-users',
      isModalOpen:false,
      MultiUserModalOpen:false,
      lookup_layout:{},
      displayName:'',
      lookupAutoComplete:[],
      lookup_window_name:{},
      multipleUserDisplayName:{},
      multipleUserLookupAutoComplete:{},
      isChangeOwnerModal:false,
      savedSelectedValue:'',
    }
    this.handleDelete = this.handleDelete.bind(this);
    this.handleAddition = this.handleAddition.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
    this.handleTagClick = this.handleTagClick.bind(this);
  }
  
  dummyMethod = ()=>{
    // alert('ss');
  }
  reloadUserDataContent = ()=>{
    const {item} = this.props;
    this.LayoutsFormsList('');
      this.setState({
        multipleUserDisplayName:{...this.state.multipleUserDisplayName,[this.props.item.id]:""},
        multipleUserLookupAutoComplete:{...this.state.multipleUserLookupAutoComplete,[this.props.item.id]:""}
      });
      setTimeout(() => {
        // console.log('USER-FIELD',item.selectedValue);
        try {
          if(item.selectedValue!==null && item.selectedValue!==''){
            console.log('item.selectedValue==',item.selectedValue)
             const selectedValueJSON = JSON.parse(item.selectedValue);
              // const selectedValue  = selectedValueJSON.id;
              // console.log(selectedValue);
              let displayName = [];
              let selectedValue = [];
              let multiUserSelectedValue = [];
              selectedValueJSON.map((data)=>{
                displayName.push(data.first_name+' '+data.last_name);
                selectedValue.push(data.id);
                multiUserSelectedValue.push({
                  text:data.first_name+' '+data.last_name,
                  label:data.first_name+' '+data.last_name,
                  id:data.id,
                  value:data.id
                })
              });
              // console.log(multiUserSelectedValue);
              // this.setState({multipleUserDisplayName:
              //   {
              //     ...this.state.multipleUserDisplayName,
              //     [item.id]:multiUserSelectedValue,
              //   }
              // });
            // console.log(multiUserSelectedValue,selectedValue);
            if(item.is_single_user_reference===true){
              this.setLookupValuesFromList({label:displayName.join(''),value:selectedValue.join(',')});
            }else{
              this.setState({
                multipleUserDisplayName:{
                  ...this.state.multipleUserDisplayName,
                  [item.id]:multiUserSelectedValue
                  }
              });
              this.setLookupValuesFromList({label:displayName.join(''),value:selectedValue.join(',')});
            }
          }else{
            const userInfo = getUserInfo();
            let displayName = [];
            displayName.push(userInfo.data.first_name+'' +userInfo.data.last_name);
            this.setState({
              multipleUserDisplayName:{
                ...this.state.multipleUserDisplayName,
                [item.id]:[...this.state.multipleUserDisplayName[item.id], {
                  text:userInfo.data.first_name+' '+userInfo.data.last_name,
                  label:userInfo.data.first_name+' '+userInfo.data.last_name,
                  id:userInfo.data.id,
                  value:userInfo.data.id
                }]
                }
            });
            this.setLookupValuesFromList({label:displayName.join(''),value:userInfo.data.id});
          }
          
            
        } catch (e) {
            console.log(e);
        }
      }, 200);
  }
  componentDidUpdate = (prevProps)=>{
    if(prevProps.item.api_field_name!==this.props.item.api_field_name){
      this.reloadUserDataContent();
    }
  }
  componentDidMount = ()=>{
    this.reloadUserDataContent();
    // this.LayoutsFormsList('');
    // // console.log('dss');
    // const {item} = this.props;
    // this.setState({
    //   multipleUserDisplayName:{...this.state.multipleUserDisplayName,[this.props.item.id]:""},
    //   multipleUserLookupAutoComplete:{...this.state.multipleUserLookupAutoComplete,[this.props.item.id]:""}
    // });
    // setTimeout(() => {
    //   // console.log('USER-FIELD',item.selectedValue);
    //   try {
    //     if(item.selectedValue!==null && item.selectedValue!==''){
    //       console.log('item.selectedValue==',item.selectedValue)
    //        const selectedValueJSON = JSON.parse(item.selectedValue);
    //         // const selectedValue  = selectedValueJSON.id;
    //         // console.log(selectedValue);
    //         let displayName = [];
    //         let selectedValue = [];
    //         let multiUserSelectedValue = [];
    //         selectedValueJSON.map((data)=>{
    //           displayName.push(data.first_name+' '+data.last_name);
    //           selectedValue.push(data.id);
    //           multiUserSelectedValue.push({
    //             text:data.first_name+' '+data.last_name,
    //             label:data.first_name+' '+data.last_name,
    //             id:data.id,
    //             value:data.id
    //           })
    //         });
    //         // console.log(multiUserSelectedValue);
    //         // this.setState({multipleUserDisplayName:
    //         //   {
    //         //     ...this.state.multipleUserDisplayName,
    //         //     [item.id]:multiUserSelectedValue,
    //         //   }
    //         // });
    //       // console.log(multiUserSelectedValue,selectedValue);
    //       if(item.is_single_user_reference===true){
    //         this.setLookupValuesFromList({label:displayName.join(''),value:selectedValue.join(',')});
    //       }else{
    //         this.setState({
    //           multipleUserDisplayName:{
    //             ...this.state.multipleUserDisplayName,
    //             [item.id]:multiUserSelectedValue
    //             }
    //         });
    //         this.setLookupValuesFromList({label:displayName.join(''),value:selectedValue.join(',')});
    //       }
    //     }else{
    //       const userInfo = getUserInfo();
    //       let displayName = [];
    //       displayName.push(userInfo.data.first_name+'' +userInfo.data.last_name);
    //       this.setState({
    //         multipleUserDisplayName:{
    //           ...this.state.multipleUserDisplayName,
    //           [item.id]:[...this.state.multipleUserDisplayName[item.id], {
    //             text:userInfo.data.first_name+' '+userInfo.data.last_name,
    //             label:userInfo.data.first_name+' '+userInfo.data.last_name,
    //             id:userInfo.data.id,
    //             value:userInfo.data.id
    //           }]
    //           }
    //       });
    //       this.setLookupValuesFromList({label:displayName.join(''),value:userInfo.data.id});
    //     }
        
          
    //   } catch (e) {
    //       console.log(e);
    //   }
    // }, 200);
    
  }
  //MODAL POPUP FOR ADD NEW - OPEN
  openLoopupModalHandler = (isSingleUser) =>{
    if(isSingleUser){
      this.setState({isModalOpen:true,MultiUserModalOpen:false});
    }else{
      this.setState({isModalOpen:false,MultiUserModalOpen:true});
    }
  }
  //MODAL POPUP - CANCEL
  cancelLoopupModalHandler = () =>{
    this.setState({isModalOpen: false,MultiUserModalOpen:false});
  }

  setMultiLookupValuesFromList =(res)=>{ 
    const {item} = this.props;
    let multiUserDisplayName =[];
    this.setState({
      multipleUserDisplayName:{
        ...this.state.multipleUserDisplayName,
        [item.id]:res.multiUserDisplayList
        }
    });
    res.multiUserDisplayList.map((selectedLookup)=>{       
      multiUserDisplayName.push(selectedLookup.text)
    });
    this.props.onChangeInputAction(this.props.fieldObj,{selectedValue:res.value,displayValue:multiUserDisplayName.join(',')},'Lookup');
  }

  setLookupValuesFromList = (res) =>{
    // console.log('USER-FIELD',this.props,res.value);
    this.setState({displayName:res.label});
    this.props.onChangeInputAction(this.props.fieldObj,{selectedValue:res.value,displayValue:res.label},'Lookup');
  }


  LayoutsFormsList =(value) =>{
    const windowName = this.props.windowName;
    const page = 0;//pagination.page; 
    const orderBy = '';//pagination.orderBy; 
    let perPage = 10;//pagination.perPage'
    if(value===undefined || value === ''){
      perPage = 0;
    }  
    const direction = 'ASC';//pagination.direction; 
    const search = value;
    const queryString = '?query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction;
    http.GET('users/fetch-users/active'+queryString)
    .then(res => {
      if(res.status===200){ 
        const response = res.data;
        if(response.code===200){
          let updateTableData = [];
          this.setState({lookup_layout:{
            moduleId:response.data.module_id,
            windowId:response.data.window_id,
            windowName:this.props.item.value
          }});
          response.data.content.map((item)=>{
            updateTableData.push({
              label:item.first_name+' '+item.last_name,
              value:item.id,
              id:item.id,
              text:item.first_name+' '+item.last_name
            });
        })
        // console.log(updateTableData);
        this.setState({lookupAutoComplete:updateTableData,multipleUserLookupAutoComplete:
            {...this.state.multipleUserLookupAutoComplete,[this.props.item.id]:updateTableData
              
            }
        });
        }else{
          this.setState({lookupAutoComplete:[],multipleUserLookupAutoComplete:{}});
        }
      }
    })
  }
  autoCompleteSelect = (obj) =>{
    this.setLookupValuesFromList({label:obj.label,value:obj.value})
  }
  autoCompleteSearch = (value) =>{
    this.setState({displayName:value});
    this.LayoutsFormsList(value);
  }
     // DELETE/CANCEL ADDED LOOKUP VALUES
     handleDelete(i) {
      console.log(i);
      const {item} = this.props;
      if(i!==-1){
          this.setState({
            multipleUserDisplayName:{
              ...this.state.multipleUserDisplayName,
              [item.id]:this.state.multipleUserDisplayName[item.id].filter((tag, index) =>{
                  if(index !== i){
                      return tag;
                  }
              }),
              }
          });
          this.updateSuggestionLookup();
      }
    }
    //ADD WHEN SELECT FROM SUGGESTION
    handleAddition(tag) {
        const {item} = this.props;
        if(tag.value===undefined){
        }else{
            this.setState({
              multipleUserDisplayName:{
                ...this.state.multipleUserDisplayName,
                [item.id]:[...this.state.multipleUserDisplayName[item.id], tag]
                }
            });
            this.updateSuggestionLookup();
        }
    }
    //UPDATE/ADD SELECTED VALUES ID ONCE ADDED
    updateSuggestionLookup = ()=>{
        setTimeout(() => {
            const {item,itemIndex} = this.props;
            let selectedLookupArr = [];
            let selectedDisplayName = [];
            this.state.multipleUserDisplayName[item.id].map((selectedLookup)=>{
                selectedLookupArr.push(selectedLookup.id);
                selectedDisplayName.push(selectedLookup.text);
            });
            this.props.onChangeInputAction(this.props.fieldObj,{selectedValue:selectedLookupArr.join(','),displayValue:selectedDisplayName.join(',')},'Lookup');            // this.props.valueChangeHandler(this,itemIndex,selectedLookupArr.join(','),'field_value','Lookup');
        }, 300);
    }
    //DRAG AND SORT SELECTED/ADDED LOOKUP VALUES
    handleDrag(tag, currPos, newPos) {
        // const tags = [...this.state.tags];
        // const newTags = tags.slice();
        // newTags.splice(currPos, 1);
        // newTags.splice(newPos, 0, tag);
        // this.setState({ tags: newTags });
    }

    //HANDLER CLICK
    handleTagClick(index,actionType) {
        console.log(index,actionType);
        if(actionType==='click'){
            console.log('The tag at index ' + index + ' was clicked');
        }else if(actionType==='doubleclick'){
            // console.log(this.state.tags[index]);
            // this.setState({activeIndex:index,activeTag:this.state.tags[index]});
            // var inputField = this.refs.customToogleAddTags;
            // inputField.click();
            console.log('The tag at index ' + index +' was double clicked');
        }
    }
    //SEARCHING AND LIST VALUES FROM LIST ON KEYUP
    handleInputChange = (suggestion)=>{
        this.LayoutsFormsList(suggestion);
    }
    editChangeOwner = (boll)=>{
      if(boll===false){
        console.log(this.state.savedSelectedValue);
        this.props.onChangeInputAction(this.props.fieldObj,{selectedValue:this.state.savedSelectedValue,displayValue:''},'Lookup');
        this.setState({displayName:this.state.savedDisplayName,isChangeOwnerModal:false});
      }else{
        this.setState({isChangeOwnerModal:boll,
          savedSelectedValue:this.props.item.selectedValue,
        savedDisplayName:this.state.displayName});
      }
    }
    onSaveChangeOwnerHandler = ()=>{
      this.setState({isChangeOwnerModal:false});
      const params = this.props.match.params;
      const selectedValue = this.props.item.selectedValue;
      const postData = null;
      let API_Url ='table-data-engine/'+params.windowName+'/change-owner?ownerId='+selectedValue+'&metatableId='+params.formId;
         http.POST(API_Url,postData)
          .then((res) => {
            if(res.status===200){ 
              const response = res.data;
              if(response.code===200){
                // this.props.succMessage((res.data.message)?res.data.message:''+params.windowName+' created successfully');
              }else if(response.code===400){
                const violations = response.violations;
                let validationMsgArr = [];
                violations.map((fields)=>{
                  validationMsgArr.push(fields.message);
                });
                if(validationMsgArr.length===0){
                  this.props.failMessage(response.message);
                }else{
                  this.props.failMessage(validationMsgArr.join('</br>'));
                }
              }else{
                this.props.failMessage(response.message);
              }
            }
            
          }, (error) => {
            // this.props.Loader();
            this.props.failMessage("Something went wrong while update user");
            console.log(error);
          });
    }
  render() {
    const  {
      item,
      className,
      section,
      validationForms,
      subformObj
    } = this.props;
   
    const attr = formFieldsAttributes(
      {...item,className:className,hideMandatory:true
    },validationForms);
    // item.is_single_user_reference = false;
    // console.log(this.state.multipleUserDisplayName);
    const {isChangeOwnerModal, multipleUserLookupAutoComplete, multipleUserDisplayName} = this.state;
    // const params = this.props.match.params;
    const params = (this.props.isPopupWindow===true)?this.props.windowDetails:this.props.match.params;
    try{
      // console.log(this.state.lookupAutoComplete);
      return (
        <Wrp>
        <FormBlocks {...this.props}  attr={attr}>
          <div className="input-group autocomplete">
            <input 
              type="hidden"
              value={attr.value}
              {...attr.fieldAttributes}
            />
            {(item.is_single_user_reference===true)?
              <Wrp>
                <Autocomplete
                attributes={attr.fieldAttributes}
                suggestions={(this.state.lookupAutoComplete)?this.state.lookupAutoComplete.filter((user)=>{
                  if(user.label!==this.state.displayName){
                    return user;
                  }
                }):[]}
                search={this.autoCompleteSearch}
                select={this.autoCompleteSelect}
                isRequired={item.required}
                selectedValue={this.state.displayName}
                {...this.props}
              />
                {/* {(params.page!=='add' && item.modType==='ADDFORM')?
                  <Wrp>
                  <div className="form-control" onClick={this.editChangeOwner.bind(this,true)}>
                    {this.state.displayName}
                  </div>
                  <Modal
                  isModalOpen={isChangeOwnerModal}
                  title ={<Wrp>
                    {'Change owner'}&nbsp;-&nbsp; 
                    <span className="badge badge-info">{params.windowName}</span></Wrp>}
                  buttonList={[{
                      attributes:{
                        className:"btn border-default btn-border mr-2 cursor-pointer",
                      },
                      clickHandler:this.editChangeOwner.bind(this,false),
                      name:"Cancel"
                    },  
                  {
                    attributes:{
                      className:"btn primary_bg cursor-pointer"
                    },
                    clickHandler:this.onSaveChangeOwnerHandler,
                    name:"Save"
                  }]} >
                    <div className="input-group autocomplete">
                      <Autocomplete
                    attributes={attr.fieldAttributes}
                    suggestions={this.state.lookupAutoComplete}
                    search={this.autoCompleteSearch}
                    select={this.autoCompleteSelect}
                    selectedValue={this.state.displayName}
                    {...this.props}
                  /></div>
                  </Modal>
                </Wrp>
                :
                <Autocomplete
                attributes={attr.fieldAttributes}
                suggestions={this.state.lookupAutoComplete}
                search={this.autoCompleteSearch}
                select={this.autoCompleteSelect}
                isRequired={item.required}
                selectedValue={this.state.displayName}
                {...this.props}
            />} */}
              
              {/* {(params.page==='add' && item.modType!=='QUICKFORM')?   */}
              <div className={(item.required===true)? "input-group-append mandatory":"input-group-append"} onClick={()=>(item.modType!=='QUICKFORM')?this.openLoopupModalHandler(item.is_single_user_reference):{}}> <a className="input-group-text"><i className={this.state.lookupIcon}></i></a></div>
              {/* :''} */}
            </Wrp>
            :
            <div className="input-group autocomplete">
            <ReactTags
                tags={
                    (this.state.multipleUserDisplayName[item.id])?
                    this.state.multipleUserDisplayName[item.id]:[]
                }
                placeHolder={'Search here..'}
                suggestions={
                    (this.state.multipleUserLookupAutoComplete[item.id])?
                    this.state.multipleUserLookupAutoComplete[item.id].filter((users) =>{
                      if(multipleUserDisplayName[item.id].length >0 && multipleUserDisplayName[item.id]?.findIndex(itm => itm?.label === users.label) === -1){
                        return users;
                      }else if(multipleUserDisplayName[item.id].length  === 0 ){
                        return users;
                      }
                    }):[]
                }
                delimiters={delimiters}
                handleDelete={this.handleDelete}
                handleAddition={this.handleAddition}
                handleDrag={this.handleDrag}
                handleInputChange={this.handleInputChange}
                handleTagClick={this.handleTagClick}
            />
             <div attr={params.page} mod={item.modType}  className={(item.required===true)? "input-group-append mandatory":"input-group-append"} onClick={()=>(item.modType!=='QUICKFORM')?this.openLoopupModalHandler(item.is_single_user_reference):this.dummyMethod()}> <a className="input-group-text"><i className={this.state.lookupIcon}></i></a></div>
            </div>
            }
              
            
          </div>
        </FormBlocks>
       {(item.is_single_user_reference)?
            <SingleUserModal 
            {...this.props}
            item={item}
            isModalOpen={this.state.isModalOpen} 
            windowName={item.value}
            selectedValue={item.selectedValue}
            cancelLoopupModalHandler={this.cancelLoopupModalHandler} 
            setLookupValuesFromList={this.setLookupValuesFromList}
            lookup_layout={this.state.lookup_layout}
            />:
            <MultiUserModel
            {...this.props} 
            item={item}
            isModalOpen={this.state.MultiUserModalOpen} 
            windowName={item.value}
            selectedValue={item.selectedValue}
            cancelLoopupModalHandler={this.cancelLoopupModalHandler} 
            multipleUserDisplayName={this.state.multipleUserDisplayName[item.id]}
            setMultiLookupValuesFromList={this.setMultiLookupValuesFromList}
            lookup_layout={this.state.lookup_layout}
            />
          } 
        </Wrp>
      
      );  
    }catch(e){
      // this.props.failMessage("Something went wrong while removing layout");
    }
    
  }
}

UserField.defaultProps = {
  className: "form-control custom-arrow",
}

export default withRouter(UserField);
